import { call, put, select } from 'redux-saga/effects'
import {
  deleteBanner,
  filterBanners,
  modifyStatus,
  setBannerPageProcessing,
  setBannerProcessing,
  setBanners,
  setError,
  setFlashSale,
  setLoading,
  setNewBanner,
  setPages,
  setRearrangedBanners,
  setUpdatedBanner,
} from '../../slices/bannerSlices'

import { toast } from 'react-toastify'
import {
  getAllBannersByType,
  putBannerType,
  requestBannerList,
  requestBannerPages,
  requestBannersByType,
  requestCreateBanner,
  requestCreateBannerType,
  requestDeleteBanner,
  requestDeleteBannerType,
  requestFeaturedBanners,
  requestRearrangeBanners,
  requestToggleBanner,
  requestUpdateBanner
} from '../requests/bannerService';
import { getFlashSale } from '../requests/productService'
import { setAppLoading } from '../../slices/authTokenSlice'
import { setLoading as setDLoading } from 'redux/slices/dynamicMultipleElementsSlice'
import { setResult } from 'redux/slices/dynamicMultipleElementsSlice'

function* handleFetchBanners(action) {
  const { apiCall, screen, tab, isPrev = false } = action.payload
  const {
    pages: { selectedPage, data },
    banners: { activeTab, page },
  } = yield select((state) => state.banner)
  const activePage = data.find((d) => d.id === selectedPage)
  const element = 'banners'
  try {
    yield put(setLoading({ element, loading: true }))
    if (apiCall) {
      const response = yield call(() =>
        requestBannersByType(activePage.id, isPrev ? page - 1 : page + 1),
      )
      yield put(
        setBanners({
          response: response.data,
          screen: screen,
          tab: tab,
        }),
      )
    } else {
      yield put(
        filterBanners({ screen: activePage.title, tab: activeTab.value }),
      )
    }
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(setError({ error: errMsg, element }))
  }
}

function* handleCreateBanner(action) {
  const {
    pages: { selectedPage, data },
    banners: { activeTab },
  } = yield select((state) => state.banner)
  const { banner, bannerTypeId } = action.payload
  const activePage = data.find((d) => d.id === selectedPage)
  try {
    yield put(setBannerProcessing(true))
    const response = yield call(() => requestCreateBanner(bannerTypeId, banner))
    yield put(
      setNewBanner({
        newBanner: response.data,
        screen: activePage.title,
        tab: activeTab.value,
        canPush: selectedPage === bannerTypeId,
      }),
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setBannerProcessing(false))
  }
}

function* handleToggleBannerStatus(action) {
  const { payload } = action.payload
  const {
    pages: { selectedPage, data },
    banners: { activeTab },
  } = yield select((state) => state.banner)
  try {
    yield put(setAppLoading(true))
    const activePage = data.find((d) => d.id === selectedPage)
    const response = yield call(() =>
      requestToggleBanner(activePage.id, payload),
    )
    yield put(
      modifyStatus({
        banner: response.data,
        screen: activePage.title,
        tab: activeTab.value,
      }),
    )
    toast.info('Action completed successfully!')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

function* handleRemoveBanner(action) {
  const { bannerId } = action.payload
  const {
    pages: { selectedPage, data },
    banners: { activeTab },
  } = yield select((state) => state.banner)
  const activePage = data.find((d) => d.id === selectedPage)
  try {
    yield put(setAppLoading(true))
    yield call(() => requestDeleteBanner(bannerId))
    yield put(
      deleteBanner({
        bannerId,
        screen: activePage.title,
        tab: activeTab.value,
      }),
    )
    toast.info('Banner deleted successfully!')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

function* handleRearrangeBanner(action) {
  const { activeBannerId, payload } = action.payload
  const {
    pages: { selectedPage, data },
    banners: { activeTab },
  } = yield select((state) => state.banner)
  try {
    yield put(setAppLoading(true))
    const activePage = data.find((d) => d.id === selectedPage)
    const response = yield call(() =>
      requestRearrangeBanners(activePage.id, activeBannerId, payload),
    )
    yield put(
      setRearrangedBanners({
        banners: response.data,
        screen: activePage.title,
        tab: activeTab.value,
      }),
    )
    toast.info('Priority changed successfully!')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

function* handleGetActiveFlashSale() {
  try {
    yield put(setFlashSale({ loading: true }))
    const response = yield call(() => getFlashSale())
    yield put(setFlashSale({ loading: false, flashSale: response }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(setFlashSale({ loading: false, error: errMsg }))
  }
}

function* handleUpdateBanner(action) {
  const { banner, bannerId, bannerTypeId } = action.payload
  const {
    pages: { selectedPage, data },
    banners: { activeTab },
  } = yield select((state) => state.banner)
  const activePage = data.find((d) => d.id === selectedPage)
  try {
    yield put(setBannerProcessing(true))
    const response = yield call(() =>
      requestUpdateBanner(bannerTypeId, bannerId, banner),
    )
    yield put(
      setUpdatedBanner({
        data: response.data,
        bannerId,
        screen: activePage.title,
        tab: activeTab.value,
      }),
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setBannerProcessing(false))
  }
}

function* handleFetchBannerPage() {
  try {
    const element = 'pages'
    yield put(setLoading({ element, loading: true }))
    const { data: pages } = yield call(() => requestBannerPages())
    yield put(setPages({ data: pages.data }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  }
}

function* handleCreateBannerPage(action) {
  try {
    const {
      pages: { data },
    } = yield select((state) => state.banner)

    yield put(setBannerPageProcessing(true))
    const response = yield call(() => requestCreateBannerType(action.payload))
    yield put(setPages({ data: [...data, response.data] }))
    toast.success('Banner page created successfully')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setBannerPageProcessing(false))
  }
}


function* handleUpdateBannerType(action) {
  const {
    pages: { selectedPage, data },
  } = yield select((state) => state.banner)
  const activePage = data.find((d) => d.id === selectedPage)
  try {
    yield put(setBannerPageProcessing(true))
    const response = yield call(() => putBannerType(activePage.id, action.payload))
    yield put(setPages({ data: data.map((d) => d.id === response.data.id ? response.data : d) }))
    toast.success('Banner updated successfully')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setBannerPageProcessing(false))
  }
}

function* handleDeleteBannerType(action) {
  const {
      pages: { data },
    } = yield select((state) => state.banner)
  try {
    yield put(setAppLoading(true))
    yield call(() => requestDeleteBannerType(action.payload))
    yield put(setPages({ data: data.filter((d) => d.id !== action.payload) }))
    toast.success('Banner deleted successfully')
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

export function* handleGetBanners(action) {
  const element = 'dynamicBanner'
  // if(ext !== action.payload){
  try {
    yield put(setDLoading({ element, loading: true, id: action.payload }))
    const { data } = yield call(() => getAllBannersByType(action.payload))
    yield put(setResult({ data, element, id: action.payload }))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(setResult({ error: errMsg, element, id: action.payload }))
  }
  // }else{
  //   return;
  // }
}

export {
  handleFetchBanners,
  handleCreateBanner,
  handleToggleBannerStatus,
  handleRemoveBanner,
  handleRearrangeBanner,
  handleGetActiveFlashSale,
  handleUpdateBanner,
  handleFetchBannerPage,
  handleCreateBannerPage,
  handleDeleteBannerType,
  handleUpdateBannerType
}
